
export default {
  name: "CardViewInvestor",
  props: {
    id: Number,
    to: String,
    textTitle: String,
    incorporatedAt: String,
    type: { type: Object, default: () => ({}) },
    investmentStage: { type: Array, default: () => [] },
    thumbnail: { type: String, default: "/images/default-image.png" },
    sectors: { type: Array, default: () => [] },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    noSector() {
      return !this.sectors.length;
    },
    hasStage() {
      return this.investmentStage.length;
    },
    isCapital() {
      return this.type == "capital";
    },
    thumbnailUrl(){
      if(this.thumbnail && this.thumbnail != ""){
        return this.thumbnail
      }else{
        return "/images/default-image.png";
      }
    }
  },
  methods: {
    onClickStage(item) {
      this.$emit("click-stage", item);
    },
    onClickIndustry(item) {
      this.$emit("click-industry", item);
    },
    onClickType() {
      this.$emit("click-type", this.type);
    },
    _showReportForm() {
      this.$refs.formReport.openForm(this.id, "investor");
    },
  },
};
